<template>
  <component
    :is="componentCard"
    class="parlay-card"
    :marketIds="marketIds"
    :eventId="eventId"
  />
</template>

<script lang="ts">
import { PropType } from "vue";
import { createUseStyles } from "@fresh8/vue-jss/src";
import { defineComponent, computed } from "vue";
import {
  injectTemplateSize,
  MPU,
  LARGE_RESPONSIVE,
  BILLBOARD
} from "@fresh8/ad-data-composition/src/useTemplateSize";
import MPUParlay from "./MPU/MPUParlay.vue";
import { provideUseTeamJerseys } from "../../../lib/teamJerseys";
import { provideUseTeamBadges } from "../../../lib/teamBranding";

const useStyles = createUseStyles({
  offerWrapper: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    position: "relative",
    flex: "1"
  }
});

export default defineComponent({
  name: "ParlayWrapper",
  props: {
    marketIds: {
      type: Object as PropType<string[]>,
      required: true
    },
    eventId: {
      type: Object as PropType<string>,
      required: true
    }
  },
  setup(props) {
    const classesRef = useStyles();
    const template = injectTemplateSize();

    provideUseTeamBadges(props.eventId);
    provideUseTeamJerseys(props.eventId);

    const componentCard = computed(() => {
      if (
        template?.size.value.name === MPU.name ||
        LARGE_RESPONSIVE.name ||
        BILLBOARD.name
      ) {
        return MPUParlay;
      }

      return undefined;
    });

    return {
      classes: classesRef.value,
      componentCard
    };
  }
});
</script>

<style></style>
